///include /assets/js/app/p/card-capture.js
class CardCaptureTwoCheckout extends CardCaptureDriver {
    static get type() {
        return "twoCheckout"
    }
    get canCapture() {
        return !!(
            CheckoutInfo.inst.info &&
            CheckoutInfo.inst.info.card &&
            CheckoutInfo.inst.info.card.type == CardCaptureTwoCheckout.type && //
            CheckoutInfo.inst.info.card.captureKey
        )
    }
    /**
     *
     * @param {?string} return_url
     * @param {boolean} [from_vue]
     */
    init(return_url = null, from_vue = true) {
        /** @type {HTMLFormElement} */
        //@ts-ignore
        const pf = document.querySelector("#payment-form")
        if(pf && !pf.getAttribute("action")) {
            const action = safeLocalUrl(return_url, null)
            if(action) {
                pf.action = action
            } else {
                throw new Error(`Invalid return URL: ${return_url}`)
            }
        }
        if(!from_vue) {
            /** @type {HTMLButtonElement} */
            //@ts-ignore
            const submit = document.querySelector(
                "#modal-add-card button.btn-primary, #card-details button.btn-primary"
            )
            submit.addEventListener(
                "click",
                async () => {
                    await this.submitForm()
                    location.href = "/account/billing-details"
                }
            )
        }
    }

    /**
     * @param {HTMLFormElement} pf
     */
    async initForm(pf) {
        if(!pf.getAttribute("action")) {
            throw new Error(`No form action, please see errors`)
        }
        this.mountPoint = `#${pf.id}`
        const ci = CheckoutInfo.inst
        const info = await ci.preloadSingle("info")
        await Site.require_once("https://2pay-js.2checkout.com/v1/2pay.js")
        await Site.require_once("/assets/js/lib/p/template-loader.js")
        await Site.require_once("/assets/js/shared/twocheckout-form.js")

        const capture_key = JSON.parse(info.card.captureKey)
        const [tco, c] = await TwocheckoutForm.init(capture_key, this.mountPoint)
        this.twoCheckout = tco
        this.component = c
    }

    async submitForm() {
        let billingDetails = {
            name: document.querySelector('#twocheckout-form-card-name').value
        };

        const result = await this.twoCheckout.tokens.generate(this.component, billingDetails)
        .then(async response => {
            // Get the token
            return response.token
        })

        CheckoutInfo.inst.reload(["info"])
        const info = await CheckoutInfo.inst.preloadSingle("info")
        const capture_key = JSON.parse(info.card.captureKey)

        if(result.error) {
            throw new Error(result.error.message)
        } else {
            this.token = result
            /** @type {HTMLFormElement} */
            //@ts-ignore
            const pf = document.querySelector("#payment-form")
            await $.ajax({
                method: "post",
                url: pf.action,
                data: {
                    token: this.token,
                }
            }).catch(e => {
                ShowNotification.fail('An error occured. Please try again or contact support.')
                throw new Error(e)
            })
        }

        if(this.mountPoint) {
            const [tco, c] = await TwocheckoutForm.init(capture_key, this.mountPoint)
            this.twoCheckout = tco
            this.component = c
        }
    }
}
CardCaptureDriver.add(CardCaptureTwoCheckout)
